export const siteTitle = 'Phil Sinatra'
export const pages = [
  {
    course: 'EME5045',
    pages: [
      { title: 'The History of Educational Design', url: '/eme5054-timeline' },
      { title: 'Book Review Podcast', url: '/eme5054-podcast' },
    ],
  },
  {
    course: 'EME6208',
    pages: [
      { title: 'Book Cover', url: '/eme6208-book-cover' },
      { title: 'Digital Animation', url: '/eme6208-digital-animation' },
      { title: 'Educational Video', url: '/eme6208-educational-video' },
      {
        title: 'ePortfolio',
        url: 'https://pjs-eportfolio-6208.netlify.app',
        target: 'eportfolio',
      },
      { title: 'Logo', url: '/eme6208-logo' },
      { title: 'Quiz', url: '/eme6208-quiz' },
      { title: 'Screencast', url: '/eme6208-screencast' },
    ],
  },
  {
    course: 'EME6609',
    pages: [
      {
        title: 'Needs Assessment',
        url: '/eme6609-needs-assessment',
      },
      {
        title: 'PowerPoint Elevation',
        url: '/eme6609-ppt-elevation',
      },
      {
        title: 'Lesson Plan',
        url: '/eme6609-lesson-plan',
      },
      {
        title: 'Interactive Video',
        url: '/eme6609-interactive-video',
      },
      {
        title: 'Final ID Project',
        url: '/eme6609-final-id-project',
      },
    ],
  },
]
